import {
  Box,
  Center,
  Flex,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';
import { FC } from 'react';
import {
  CurrentAuthState,
  useAuthContext,
} from '../../../contexts/AuthContext';
import { YapamarLogo } from '../../atoms/YapamarLogo';
import { ForgotPasswordSendCode } from './forms/ForgotPasswordSendCode';
import { ForgotPasswordUpdate } from './forms/ForgotPasswordUpdate';
import { NewPassword } from './forms/NewPassword';
import { SignIn } from './forms/SignIn';

export const AuthUIContainer: FC = () => {
  const {
    signIn,
    completeNewPassword,
    forgotPasswordStart,
    cancelForgotPassword,
    forgotPasswordSendCode,
    forgotPasswordUpdatePassword,
    currentAuthState,
  } = useAuthContext();

  const logoTheme = useColorModeValue('dark', 'white');

  return (
    <Center>
      <Box
        width="100%"
        maxWidth="760px"
        py="16px"
        borderColor="surface.border"
        background="surface.panel">
        <Flex direction="column" width="100%">
          <Flex direction="column" alignItems="center">
            <Box my={6}>
              <YapamarLogo theme={logoTheme} clickable={false} />
            </Box>
          </Flex>
          {currentAuthState === CurrentAuthState.SignedOut && (
            <SignIn onSubmit={signIn} onForgotPassword={forgotPasswordStart} />
          )}
          {currentAuthState === CurrentAuthState.ForcePasswordChange && (
            <NewPassword onSubmit={completeNewPassword} />
          )}
          {currentAuthState === CurrentAuthState.ForgotPassword && (
            <ForgotPasswordSendCode
              onSubmit={forgotPasswordSendCode}
              onCancel={cancelForgotPassword}
            />
          )}
          {currentAuthState === CurrentAuthState.PasswordReset && (
            <ForgotPasswordUpdate onSubmit={forgotPasswordUpdatePassword} />
          )}
          {currentAuthState === CurrentAuthState.Loading && (
            <Center>
              <Spinner />
            </Center>
          )}
        </Flex>
      </Box>
    </Center>
  );
};
